import React, { useContext } from 'react';
import { ApiContext } from '@api/api';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { FilterConfig, FilterType } from '@components/RingilDataTable/RingilDataTable.tsx';
import EmailHistoryTable from './EmailHistoryTable.tsx';
import { useLazyCompanies } from './useLazyCompanies.ts';

/** Cross-company email history (admin tools): admin endpoint, plus the owner-company filter. */
const AdminEmailHistory: React.FC = () => {
  const { findEmailRecipients, batchResendResolvedEmails } = useContext(ApiContext);
  const { tr } = useTranslationLgs();
  const { options, loading, onLazyLoad, resolveSelected } = useLazyCompanies();

  const extraFilters: FilterConfig[] = [
    {
      filterType: FilterType.DropdownLazy,
      label: tr('EmailHistory.company', 'Company'),
      placeholder: tr('EmailHistory.company', 'Company'),
      value: ['ownerCompanyId'],
      options,
      onLazyLoad,
      lazyLoading: loading,
      defaultShown: true,
      dataTestId: 'email-history-filter-company',
    },
  ];

  return (
    <EmailHistoryTable
      fetchPage={findEmailRecipients}
      resendBatch={batchResendResolvedEmails}
      filterName="admin_email_history"
      extraFilters={extraFilters}
      onFilterChange={filter => resolveSelected(filter.ownerCompanyId)}
    />
  );
};

export default AdminEmailHistory;
